import React from "react";
import { Tabs } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import {
  CumulativePerformance,
  ThisMonthPerformance,
  PerSitePerformance,
} from "../../../components/PerformanceCards";
import enrollment from "../../../assets/icons/FOR DEMO ONLY/enrollment_demo.png";

const Enrollment2 = () => {
  const items = [
    {
      key: "1",
      label: "Enrollment Forecast",
      children: (
        <div className="flex flex-col w-full justify-center gap-4 items-center">
          <div className="flex flex-row justify-center gap-4 items-center w-full">
            <div className="flex flex-row gap-2 items-center">
              <div className="h-4 w-4 bg-[#D3EFF9]" />
              <p>Actual</p>
            </div>
            <div className="flex flex-row gap-2 items-center">
              <div className="h-4 w-4 bg-[#F6EBF2] flex flex-col justify-center items-center">
                <div className="h-1 w-4 bg-[#991B62]" />
              </div>
              <p>Forecast</p>
            </div>
          </div>

          <img
            src={enrollment}
            alt="Enrollment"
            className="max-w-[1200px] w-full"
          />
        </div>
      ),
    },
    {
      key: "2",
      label: "Per-Site Performance",
      disabled: true,
    },

    {
      key: "3",
      label: "Retention Analytics",
      disabled: true,
    },
  ];
  return (
    <div className="px-4 py-4">
      <div className="flex flex-row justify-between gap-4 bg-white px-6 rounded-md items-top pb-4">
        <Tabs className="w-full" items={items} />
        <div className="mt-4">
          <EllipsisOutlined style={{ fontSize: "24px" }} />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        <CumulativePerformance />
        <ThisMonthPerformance />
        <PerSitePerformance />
      </div>
    </div>
  );
};

export default Enrollment2;
